import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';
import { type SessionType } from '@/types/dtos/sessions/session-type.enum';

export const updateSessionSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    type: z.string().min(1, t('session.validation.sessionTypeRequired')) as z.ZodType<SessionType>,
    title: z.string().min(2, t('session.validation.titleMinLength')).max(256, t('session.validation.titleMaxLength')),
    description: z.string().optional(),
    plannedDurationMinutes: z.string().optional(),
  });
};
